import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { getToken } from '../../../../helpers/Jwt';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RichTextEditor from './RichTextEditor';

const EntryNews = () => {
    const { id } = useParams();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [text, setText] = useState("");
    const [detailData, setDetailData] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_NEWS = "api/kejati/dashboard/news";

    const fetchData = async (url, headers) => {
        setLoading(true);
        try {
            const response = await axios.get(url, { headers });
            return response.data;
        } catch (err) {
            setError("Gagal memuat data. Silakan coba lagi.");
            console.error(err);
            return null;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) {
            fetchData(`${BASE_URL}${PATH_NEWS}/detail?id=${id}`, {
                Authorization: `Bearer ${getToken()}`,
                "Content-Type": "application/json"
            }).then((detail) => {
                setDetailData(detail);
                setText(detailData?.article)
            });
        }
    }, [id]);

    return (
        <div className="font-sans p-6 min-h-screen">
            <div className='flex justify-between'>
                <h1 className="text-2xl font-bold text-gray-800 mb-6">
                    {id ? `Ubah Data Berita` : 'Tambah Data Berita'}
                </h1>
            </div>
            {loading ? (
                <p>Memuat Data Berita...</p>
            ) : (
                <div className='p-3 rounded-lg shadow-md bg-white'>
                    <RichTextEditor value={detailData?.article} onChange={setText} />
                </div>
            )}
        </div>
    )
}

export default EntryNews;